module.exports = __webpack_public_path__ + "static/media/temp_9.91973da5.jpg";